import { BackendValidationErrorConfig, handleBackendValidationError } from "@app/shared/utils/error-handler.util";
import { TranslateService } from "@ngx-translate/core";
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  private translateService = inject(TranslateService);

  constructor() {}
    handleBackendValidationError(error: any, operation: 'create' | 'update' | 'delete'): { severity: string; summary: string; detail: string } {
        const config: BackendValidationErrorConfig = {
        errorPatterns: [
            { patterns: ['The shop code'], key: 'common.validation.code_exists' },
            { patterns: ['Warehouse name already exists'], key: 'retailStore.form.validation.warehouse_name_exists' },
            { patterns: ['Allocation for ratio-virtual warehouse'], key: 'onlineStore.form.validation.allocation_ratio_range' },
        ],
        defaultErrorKeys: {
            create: 'retailStore.messages.create_error',   
            update: 'retailStore.messages.update_error',
            delete: 'retailStore.messages.delete_error'
        }
        };

        return handleBackendValidationError(error, operation, config, this.translateService);
    }
}